import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import logo from "./../assets/logo.png";
import api from "./../services/api";
import {
  setUser,
  restart as restartLogin,
  setEmpresaID,
  setBanco,
} from "./../store/login";
import SelEmpresas from "./selEmpresas";

import { useDispatch, useSelector } from "react-redux";
import {
  isAuthenticated,
  ReadDataStorage,
  WriteDataStorage,
  TOKEN_KEY,
  USERNAME,
  EMP_DATA,
} from "./../services/auth";

import { ValidationForm, TextInput } from "react-bootstrap4-form-validation";

import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { NotificationManager } from "react-notifications";

import loadingButton from "./../components/buttons";
const bancos = [
  { value: "setabd", label: "Coalumaq" },
  { value: "goiasloc", label: "GoiásLoc" },
]
export default function Login(props) {
  const _banco_ = useSelector((state) => state.banco);

  const [update, setUpdate] = useState(false);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [showEmpresas, setShowEmpresas] = useState(false);
  const [banco, setBancoDados] = useState(_banco_ || ReadDataStorage('BD_SETA_BD') || "setabd");

  const dispatch = useDispatch();

  let history = useHistory();

  const matchPassword = (value) => {
    return value && value === senha;
  };

  useEffect(() => {
    const _banco = _banco_ || ReadDataStorage('BD_SETA_BD')
    console.log("login.useEffect: ", { _banco, _banco_ });
    setBancoDados(_banco)
  }, []);

  useEffect(() => {
    console.log("login.useEffect(history)");
    if (isAuthenticated()) {
      console.log("login.useEffect(history): ", "autenticated");
      let _user = ReadDataStorage(USERNAME);
      let _emp = ReadDataStorage(EMP_DATA);
      dispatch(setUser(_user));
      dispatch(setEmpresaID(JSON.parse(_emp).EMPRESAID));
      dispatch(setBanco(banco));

      history.push("/integracao");
    } else {
      console.log("login.useEffect(history): ", "not autenticated");
      //if (_passOnFocus)
      //    document.querySelector('#password').focus()
      // else
      let _user = ReadDataStorage(USERNAME);
      const _banco = _banco_ || ReadDataStorage('BD_SETA_BD')

      if (_user !== undefined || _user !== null || _user !== "") {
        setRemember(true);
        setLogin(_user);
        setBancoDados(_banco);
        document.querySelector("#password-agenda").focus();
      } else
        document.querySelector("#login-agenda").focus();

    }
  }, [history]);

  const handleSubmit = async (event) => {
    if (update)
      loadingButton(
        true,
        document.querySelector("#update-password"),
        document.querySelector("#update-password").children[0].classList,
        document.querySelector("#update-password").lastChild.nodeValue
      );
    else
      loadingButton(
        true,
        document.querySelector("#submit"),
        document.querySelector("#submit").children[0].classList,
        document.querySelector("#submit").lastChild.nodeValue
      );

    event.preventDefault();
    await WriteDataStorage('BD_SETA_BD', banco);
    console.log("login.handleSubmit: ", { login, banco })
    try {
      await api
        .post("/agenda/login", {
          login,
          senha,
          update,
          banco
        })
        .then(async (response) => {
          if (response.ok) {
            if (response.data === null) {
              NotificationManager.error(
                "Usuário ou Senha Inválido(s)",
                "Erro!",
                4000
              );
              setSenha("");
              setLogin("");
              setUpdate(false);
              document.querySelector("login").focus();
            } else {
              console.log("login.handleSubmit: ", response.data);
              await WriteDataStorage(TOKEN_KEY, JSON.stringify({ ...response.data, BANCO: banco }));
              if (remember) await WriteDataStorage(USERNAME, login);
              else localStorage.removeItem(USERNAME);
              dispatch(setUser({ ...response.data, BANCO: banco }));
              dispatch(setBanco(banco));
              props.history.push('/login')
              setShowEmpresas(true);
            }
          } else {
            NotificationManager.error(
              "Usuário ou Senha Inválido(s)",
              "Erro!",
              4000
            );
            if (update)
              loadingButton(
                false,
                document.querySelector("#update-password"),
                "fa fa-key",
                "Alterar Senha"
              );
            else
              loadingButton(
                false,
                document.querySelector("#submit"),
                "fa fa-sign-in-alt",
                "Acessar"
              );
          }
        });
    } catch (response) {
      localStorage.clear();
      if (update)
        loadingButton(
          false,
          document.querySelector("#update-password"),
          "fa fa-key",
          "Alterar Senha"
        );
      else
        loadingButton(
          false,
          document.querySelector("#submit"),
          "fa fa-sign-in-alt",
          "Acessar"
        );

      setLogin("");
      setSenha("");
      // NotificationManager.error("Usuário ou senha Inválido(s)", 'Erro!', 2000);
      //console.log(response)
    }
  };

  const handleEmpresa = () => {
    console.log("login.handleEmpresa");
    setShowEmpresas(false);
    history.push("/agenda");
  };

  return (
    <div className="background">
      {showEmpresas && <SelEmpresas handleEmpresa={handleEmpresa} />}
      <NotificationContainer />
      <div className="content">
        <div className="block-center wd-xl">
          <div className="card card-flat">
            <div className="card-header text-center bg-blue">
              <Link to="/login">
                <img
                  className="block-center rounded imgWidth"
                  src={logo}
                  alt={process.env.REACT_APP_NAME}
                />
              </Link>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "5px",
                fontSize: "12px",
                color: "#cacaca",
              }}
            >
              Versão: {process.env.REACT_APP_VERSION}
            </div>
            <div className="card-body">
              <ValidationForm onSubmit={handleSubmit} setFocusOnError={true}>
                {update === false ? (
                  <div>
                    <div className="input-group mb-4">
                      <select className="form-control" value={banco} onChange={e => setBancoDados(e.target.value)} required
                        style={{ width: "100%", borderColor: "cadetblue" }}
                        title="Selecione o banco de dados para conexão">
                        {bancos.map((item) => {
                          return (<option value={item.value} selected={item.value == banco}>{item.label}</option>)
                        })}
                      </select>
                    </div>
                    <div className="input-group mb-3">
                      <TextInput
                        name="login-agenda"
                        id="login-agenda"
                        type="text"
                        placeholder="Login"
                        required
                        style={{ width: "100%" }}
                        maxLength={60}
                        errorMessage={{
                          required: "Por favor, informe um login válido!",
                        }}
                        value={login}
                        className="form-control "
                        onChange={(e) => setLogin(e.target.value)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-group mb-2">
                      <TextInput
                        name="password-agenda"
                        id="password-agenda"
                        type="password"
                        style={{ width: "100%" }}
                        placeholder="Senha"
                        required
                        maxLength={20}
                        errorMessage={{
                          required: "Por favor, informe uma senha válida!",
                        }}
                        value={senha}
                        className="form-control"
                        onChange={(e) => setSenha(e.target.value)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-group mb-4">
                      <div className="checkbox c-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            checked={remember}
                            className="form-check-input"
                            value={remember}
                            onChange={(e) => setRemember(!remember)}
                          />
                          <span className="fa fa-check"></span>Lembrar meu login
                        </label>
                      </div>
                    </div>

                    <button
                      className="btn btn-block btn-theme mt-3"
                      type="submit"
                      id="submit"
                    >
                      <em className="fa fa-sign-in-alt"></em> Acessar
                    </button>

                    <div className="clearfix" style={{ marginTop: "15px" }}>
                      <div className="float-right">
                        <Link
                          to="#"
                          onClick={(e) => alert("Implementação não solicitada")}
                          className="text-muted"
                        >
                          Esqueceu sua senha?
                        </Link>
                      </div>
                    </div>

                  </div>
                ) : (
                  <div>
                    <div className="input-group mb-2">
                      <TextInput
                        name="password"
                        id="password"
                        type="password"
                        placeholder="Informe uma nova senha"
                        required
                        errorMessage={{
                          required: "Por favor, informe uma senha válida!",
                          pattern: "A senha devem conter pelo menos 6 dígitos.",
                        }}
                        value={senha}
                        autoFocus={true}
                        pattern="(?=.*[A-Z,0-9,!@#$%&*()-=+,.;:/}{\|}]).{6,}"
                        className="form-control"
                        onChange={(e) => setSenha(e.target.value)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-group mb-2">
                      <TextInput
                        name="confirmPassword"
                        id="confirmPassword"
                        type="password"
                        placeholder="Repita a nova senha"
                        required
                        errorMessage={{
                          required: "Por favor, informe uma senha válida!",
                          validator: "As senhas informadas não conferem.",
                          pattern: "A senha devem conter pelo menos 6 dígitos.",
                        }}
                        value={confirmPassword}
                        validator={matchPassword}
                        pattern="(?=.*[A-Z,0-9,!@#$%&*()-=+,.;:/}{\|}]).{6,}"
                        className="form-control"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="off"
                      />
                    </div>
                    <button
                      className="btn btn-block btn-theme mt-3"
                      type="submit"
                      id="update-password"
                    >
                      <em className="fa fa-key"></em> Alterar Senha
                    </button>
                  </div>
                )}
              </ValidationForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
